module.exports = __webpack_public_path__ + "img/logocom7.20e0848b.png";